module.exports = __webpack_public_path__ + "img/42_50.ae892d81.png";